import { Component, OnInit } from '@angular/core';
import {ButtonComponent} from "../../ui/button/button.component";
import {SafePipe} from "../../shared/pipes/safe/safe.pipe";
import {TranslateModule} from "@ngx-translate/core";
import {RouterLink} from "@angular/router";

@Component({
    selector: 'app-trial',
    templateUrl: './trial.component.html',
    imports: [
        ButtonComponent,
        TranslateModule,
        SafePipe,
        RouterLink
    ],
    styleUrls: ['./../website-grid.scss', './../website-pages.scss', './trial.component.scss']
})
export class TrialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
